import api from 'api'
import { PBX } from 'types/Pbx'
import { fetchWithToken } from 'utils'

/**
 * Retrieves the Pbx information
 */
const fetchPbx = async (id: string): Promise<PBX> => {
  const route = `pbxs/${id}`

  return fetchWithToken({
    method: 'GET',
    resource: api.pbx,
    path: route,
  })
    .then((response: Response) => response.json())
    .catch((err: Error) => {
      // Something wrong happened during the fetch
      console.error(err.toString())
    })
}

export default fetchPbx
